var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMintupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_214_8760)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7C4AF1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_214_8760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4344 26.3453L37.1844 23.8453C37.1324 23.7415 37.0526 23.6542 36.9538 23.5932C36.855 23.5322 36.7411 23.4999 36.625 23.5H25.375C25.2589 23.4999 25.145 23.5322 25.0462 23.5932C24.9474 23.6542 24.8676 23.7415 24.8156 23.8453L23.5656 26.3453C23.5225 26.4323 23.5001 26.528 23.5 26.625V37.25C23.5 37.5815 23.6317 37.8995 23.8661 38.1339C24.1005 38.3683 24.4185 38.5 24.75 38.5H37.25C37.5815 38.5 37.8995 38.3683 38.1339 38.1339C38.3683 37.8995 38.5 37.5815 38.5 37.25V26.625C38.4999 26.528 38.4775 26.4323 38.4344 26.3453ZM33.9422 32.0672C33.8841 32.1253 33.8152 32.1714 33.7393 32.2029C33.6635 32.2343 33.5821 32.2505 33.5 32.2505C33.4179 32.2505 33.3365 32.2343 33.2607 32.2029C33.1848 32.1714 33.1159 32.1253 33.0578 32.0672L31.625 30.6336V35.375C31.625 35.5408 31.5592 35.6997 31.4419 35.8169C31.3247 35.9342 31.1658 36 31 36C30.8342 36 30.6753 35.9342 30.5581 35.8169C30.4408 35.6997 30.375 35.5408 30.375 35.375V30.6336L28.9422 32.0672C28.8841 32.1253 28.8152 32.1713 28.7393 32.2027C28.6634 32.2342 28.5821 32.2503 28.5 32.2503C28.4179 32.2503 28.3366 32.2342 28.2607 32.2027C28.1848 32.1713 28.1159 32.1253 28.0578 32.0672C27.9997 32.0091 27.9537 31.9402 27.9223 31.8643C27.8908 31.7884 27.8747 31.7071 27.8747 31.625C27.8747 31.5429 27.8908 31.4616 27.9223 31.3857C27.9537 31.3098 27.9997 31.2409 28.0578 31.1828L30.5578 28.6828C30.6159 28.6247 30.6848 28.5786 30.7607 28.5472C30.8365 28.5157 30.9179 28.4995 31 28.4995C31.0821 28.4995 31.1635 28.5157 31.2393 28.5472C31.3152 28.5786 31.3841 28.6247 31.4422 28.6828L33.9422 31.1828C34.0003 31.2409 34.0464 31.3098 34.0779 31.3857C34.1093 31.4615 34.1255 31.5429 34.1255 31.625C34.1255 31.7071 34.1093 31.7885 34.0779 31.8643C34.0464 31.9402 34.0003 32.0091 33.9422 32.0672ZM25.1359 26L25.7609 24.75H36.2391L36.8641 26H25.1359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6191 28.5061C31.5378 28.4248 31.4413 28.3602 31.3351 28.3162C31.2288 28.2722 31.115 28.2495 31 28.2495C30.885 28.2495 30.7712 28.2722 30.6649 28.3162C30.5587 28.3602 30.4623 28.4247 30.381 28.506C30.381 28.5061 30.381 28.5061 30.3809 28.5061L27.881 31.006C27.7998 31.0873 27.7353 31.1838 27.6913 31.29C27.6473 31.3962 27.6247 31.51 27.6247 31.625C27.6247 31.74 27.6473 31.8538 27.6913 31.96C27.7353 32.0662 27.7998 32.1627 27.881 32.244L28.0578 32.0672L27.881 32.244C27.9623 32.3252 28.0588 32.3897 28.165 32.4337C28.2712 32.4777 28.385 32.5003 28.5 32.5003C28.615 32.5003 28.7288 32.4777 28.835 32.4337C28.9412 32.3897 29.0377 32.3252 29.119 32.244L29.119 32.2439L30.125 31.2374V35.375C30.125 35.6071 30.2172 35.8296 30.3813 35.9937C30.5454 36.1578 30.7679 36.25 31 36.25C31.2321 36.25 31.4546 36.1578 31.6187 35.9937C31.7828 35.8296 31.875 35.6071 31.875 35.375V31.2374L32.8809 32.2439C32.9622 32.3252 33.0587 32.3898 33.1649 32.4338C33.2712 32.4778 33.385 32.5005 33.5 32.5005C33.615 32.5005 33.7288 32.4778 33.8351 32.4338C33.9413 32.3898 34.0378 32.3252 34.1191 32.2439L33.9422 32.0672M31.6191 28.5061L31.4422 28.6828M31.6191 28.5061L31.619 28.506L31.4422 28.6828M31.6191 28.5061L34.1189 31.0059C34.1189 31.006 34.1189 31.006 34.119 31.006C34.2003 31.0873 34.2648 31.1837 34.3088 31.2899C34.3528 31.3962 34.3755 31.51 34.3755 31.625C34.3755 31.74 34.3528 31.8538 34.3088 31.9601C34.2648 32.0663 34.2002 32.1628 34.1189 32.2441L33.9422 32.0672M31.4422 28.6828C31.3841 28.6247 31.3152 28.5786 31.2393 28.5472C31.1635 28.5157 31.0821 28.4995 31 28.4995C30.9179 28.4995 30.8365 28.5157 30.7607 28.5472C30.6848 28.5786 30.6159 28.6247 30.5578 28.6828H31.4422ZM33.9422 32.0672C33.8841 32.1253 33.8152 32.1714 33.7393 32.2029C33.6635 32.2343 33.5821 32.2505 33.5 32.2505C33.4179 32.2505 33.3365 32.2343 33.2607 32.2029C33.1848 32.1714 33.1159 32.1253 33.0578 32.0672H33.9422ZM36.625 23.75L36.6252 23.75C36.6948 23.75 36.7632 23.7693 36.8224 23.8059C36.8817 23.8425 36.9296 23.8948 36.9608 23.9571C36.9608 23.9571 36.9608 23.9572 36.9608 23.9572L38.2104 26.4563C38.2104 26.4564 38.2105 26.4565 38.2105 26.4566C38.2364 26.5091 38.2499 26.5667 38.25 26.6252V37.25C38.25 37.5152 38.1446 37.7696 37.9571 37.9571C37.7696 38.1446 37.5152 38.25 37.25 38.25H24.75C24.4848 38.25 24.2304 38.1446 24.0429 37.9571C23.8554 37.7696 23.75 37.5152 23.75 37.25V26.6251C23.7501 26.5667 23.7636 26.509 23.7895 26.4567C23.7895 26.4565 23.7896 26.4564 23.7896 26.4563L25.0392 23.9572C25.0392 23.9572 25.0392 23.9571 25.0392 23.9571C25.0704 23.8948 25.1183 23.8425 25.1776 23.8059C25.2369 23.7693 25.3052 23.75 25.3748 23.75H25.375L36.625 23.75ZM24.9123 25.8882L24.7314 26.25H25.1359H36.8641H37.2686L37.0877 25.8882L36.4627 24.6382L36.3936 24.5H36.2391H25.7609H25.6064L25.5373 24.6382L24.9123 25.8882Z",
    stroke: "#101010",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_214_8760",
    x: 0.333331,
    y: 0.333331,
    width: 61.3333,
    height: 61.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.66667,
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.66667,
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_214_8760",
    result: "effect2_dropShadow_214_8760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_214_8760",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_214_8760",
    x: 23.5,
    y: 23.5,
    width: 15,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_8760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintupload);
export default __webpack_public_path__ + "static/media/mintupload.ffe68facc3c13401219a726065a5f032.svg";
export { ForwardRef as ReactComponent };